<template lang="html">
    <div class="container">

        <!-- Main Toggle -->
        <div class="row">

            <div class="col-sm-12">
                <div class="d-flex justify-content-between align-intems-center">
                    <div class="d-flex flex-column">
                        <span class="font-weight-600">Cutoff</span>
                        <span class="dark fs-small">Time for sales to close automatically</span>
                    </div>
                    <toggle-button
                        :disabled="disabled"
                        class=""
                        v-model="isCutoffActiveVal"
                        :labels="{checked: 'YES', unchecked: 'NO'}"/>
                </div>
            </div>

        </div>

        <!-- Collapsible area -->
        <div v-if="isCutoffActiveVal == true">

            <!-- Channels & Agents Selector -->
            <div class="row mt-2">

                <div class="col-sm-12">
                    <div class="d-flex flex-column">
                        <span class="font-weight-600">Affected sales channels</span>
                        <span class="dark fs-small">Select the sales channel you want to have cutoff, unselected sales channels will not have cutoff.</span>
                    </div>

                    <!-- List Channels -->
                    <div class="mt-2 text-left fs-small dark">
                        <span class="hoverLink" @click="selectAllAgent(true)">All</span>
                        <span>/</span>
                        <span class="hoverLink" @click="selectAllAgent(false)">None</span>
                    </div>
                    <div class="mt-0 px-2 py-1 bg-lightest border-light radius-normal">

                        <div v-for="channel in channelsTreated" class="d-flex">
                            <checkbox
                                :disabled="disabled"
                                v-model="channel.selected"
                                @input="channelCheckboxChanged($event, channel)"
                                class="mt-1"
                            >
                                {{channel.name}}
                            </checkbox>

                            <!-- Agent selector -->
                            <div v-if="channel.channelType == 50" class="ml-2">
                                <v-select
                                    :disabled="disabled || (selectedChannels && !selectedChannels.some(i => i.channelType == 50))"
                                    v-model="agentsChannelSelectionOption"
                                    @input="agentsChannelChanged($event)"
                                    :options="agentsChannelOptions"
                                    >
                                </v-select>

                                <agent-white-list
                                    :disabled="disabled"
                                    v-if="isCustoAgentSelection"
                                    class="mt-2"
                                    :allowedIdArray="allowedList"
                                    :blockedList="blockedList"
                                    :startAllSelected="false"
                                    @input="agentListChanged">
                                </agent-white-list>
                            </div>


                        </div>
                    </div>

                </div>

            </div>

            <!-- Time before event starts -->
            <div class="row mt-2">

                <div class="col-sm-12">
                    <div class="d-flex flex-column">
                        <span class="font-weight-600">Time before event starts</span>
                    </div>

                    <div class="d-flex align-items-center">
                        <input :disabled="disabled" type="number" size="3" v-model="cutOffTimeVal">
                        <label class="ml-2">hour(s)</label>
                    </div>

                    <!-- Soft cutoff selector -->
                    <div class="mt-2">
                        <checkbox :disabled="disabled" v-model="softCutOffVal">Soft cutoff</checkbox>
                        <span class="dark fs-small">Soft cutoff instead of closing will allow new reservations but these will require manual confirmation.</span>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import extendedVSelect from '@/extends/vue-select'
import AgentWhiteList from '@/components/inventory/products/components/AgentWhiteList'

export default {
    created: function () {
        // if the agents array is empty we can selete the option "All Agents"
        this.agentsChannelSelectionOption = (!this.selectedAgents || this.selectedAgents.length == 0)? this.agentsChannelOptions[0] : this.agentsChannelOptions[1]

        // fill the allowed agents on "allowedList"
        if(this.selectedAgents){
            this.allowedList = JSON.parse(JSON.stringify(this.selectedAgents.map(a => a.agentId)))
        }
    },
    data: function () {
        return {
            agentsChannelSelectionOption: null,
            agentsChannelOptions: [
                {
                    label: 'All Agents',
                    value: false
                },
                {
                    label: 'Agent Selection',
                    value: true
                }
            ],
            allowedList: [],
            blockedList: [],
        }
    },
    props:{
        disabled: {
            type: Boolean,
            default: false
        },
        isCutoffActive: {
            type: Boolean,
            default: false,
        },
        selectedChannels: {
            type: Array,
            default: function () {
                return []
            }
        },
        selectedAgents: {
            type: Array,
            default: function () {
                return []
            }
        },
        cutOffTime: {
            type: Number,
            default: 1
        },
        softCutOff: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            'getSalesChannels'
        ]),
        isCutoffActiveVal: {
            get: function (){
                return this.isCutoffActive
            },
            set: function (e){
                this.$emit('update:isCutoffActive', e)
                this.somehtingChanged()
            }
        },
        channelsTreated: function () {
            var channels = this.getSalesChannels.map(salesChannel => {
                // mark channels as selectd if thei are present on the "selectedChannels" array
                let foundSalesChannel = this.selectedChannels? this.selectedChannels.find(salesChannelSelected => {
                    return salesChannelSelected.channelId == salesChannel.id
                }) : false

                if(foundSalesChannel){
                    salesChannel.selected = true
                } else {
                    salesChannel.selected = false
                }

                // mokes "channelId" key with the value from id
                let dummySalesChannel = JSON.parse(JSON.stringify(salesChannel))
                dummySalesChannel.channelId = JSON.parse(JSON.stringify(dummySalesChannel.id))
                dummySalesChannel.id = null

                return dummySalesChannel
            })

            return channels.sort(function(channelA, channelB) {
                if(channelA.name > channelB.name){
                    return 1;
                } else if (channelA.name < channelB.name) {
                    return -1;
                } else {
                    return 0;
                }
            })
        },
        cutOffTimeVal: {
            get: function (){
                return this.cutOffTime
            },
            set: function (e){
                this.$emit('update:cutOffTime', Number(e))
                this.somehtingChanged()
            }
        },
        softCutOffVal: {
            get: function (){
                return this.softCutOff
            },
            set: function (e){
                this.$emit('update:softCutOff', e)
                this.somehtingChanged()
            }
        },
        isCustoAgentSelection: function () {
            return this.agentsChannelSelectionOption && this.agentsChannelSelectionOption.value == true
        }
    },
    methods: {
        channelCheckboxChanged: function (event, channel) {
            if(channel.channelType == 50 && event == false) {
                this.$emit('update:selectedAgents', [])
                this.somehtingChanged()
                this.agentsChannelSelectionOption = this.agentsChannelOptions.find(i => i.value == false)
            }


            this.$emit('update:selectedChannels', this.channelsTreated.filter(salesChannel => salesChannel.selected))
            this.somehtingChanged()
        },
        selectAllAgent: function(selectAll) {
            if(this.disabled == true){
                return false
            }

            if(selectAll){
                this.$emit('update:selectedChannels', this.channelsTreated)
            } else {
                this.$emit('update:selectedChannels', [])
            }
            this.somehtingChanged()
        },
        agentsChannelChanged: function (e) {
            if(e.value == false){
                this.agentListChanged([])
            }
        },
        agentListChanged: function (e) {
            this.$emit('update:selectedAgents', e.filter(agent => agent.selected))
            this.somehtingChanged()
        },
        somehtingChanged: function () {
            this.$emit('change')
        }
    },
    components: {
        AgentWhiteList,
        vSelect: extendedVSelect,
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// cutoffManager.vue?3d45f3a4